import React from 'react';

const Disclaimer = () => {
	return (
		<small>*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.</small>
	);
};

export default Disclaimer;